import { render, staticRenderFns } from "./CompanyDetail.vue?vue&type=template&id=3c159b5a&scoped=true&"
import script from "./CompanyDetail.vue?vue&type=script&lang=js&"
export * from "./CompanyDetail.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDetail.vue?vue&type=style&index=0&id=3c159b5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c159b5a",
  null
  
)

component.options.__file = "CompanyDetail.vue"
export default component.exports